import styled from "@emotion/styled";
import { ActionButton } from "../../../components/ActionButton/ActionButton";

export const ProductImage = styled.img`
  height: 155px;
  align-self: stretch;
  aspect-ratio: 1/1;
  width: 100%;
  object-fit: cover;
  border-radius: 8px 8px 0px 0px;
  display: block;
`;
export const StyledActionButton = styled(ActionButton)`
  width: 100%;
`;
